// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33Dst","content":"styles_content__RHmKz","tableWrap":"styles_tableWrap__3fl_T"};